import React, { useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import { skillsData } from '../../data/skillsData';
import { skillsImage } from '../../utils/skillsImage';
import './Skills.css';

function Skills() {
    const { theme } = useContext(ThemeContext);

    const skillBoxStyle = {
        backgroundColor: theme.secondary,
        boxShadow: `0px 0px 30px ${theme.primary30}`
    }

    const categoryStyle = {
        color: theme.primary,
        borderBottom: `2px solid ${theme.primary}`
        
    }

    // Categorize skills
    const frontendSkills = ['HTML', 'CSS', 'JavaScript', 'TypeScript', 'React Native', 'React JS', 'Next.js', 'T3', 'Redux', 'Chakra-UI', 'Bootstrap', 'Electron'];
    const backendSkills = ['Node.js', 'Express.js', 'Prisma', 'Drizzle', 'MongoDB', 'MySQL', 'PHP', 'Express', 'Firebase', 'Java', 'PostgreSQL', 'Robot Framework', 'Selenium', 'C++'];
    const platformSkills = ['VS Code', 'Github', 'Git','Microsoft Office','Figma', 'CodePen', 'Postman', 'Vercel', 'Xcode', 'AWS', 'Android Studio', 'Docker', 'Wordpress'];

    // Filter skills based on categories
    const getSkillsByCategory = (category) => {
        return skillsData.filter(skill => category.includes(skill));
    }

    return (
        <div className="skills" id="skills" style={{backgroundColor: theme.secondary}}>
            <div className="skillsHeader">
                <h2 style={{color: theme.primary}}>Technical Skills</h2>
            </div>
            
            <div className="skillsCategories">
                {/* Frontend Skills */}
                <div className="skillCategory">
                    <h3 style={categoryStyle}>
                        <span style={{color: 'white'}}>Front</span>
                        <span style={{color: theme.primary}}>end</span>
                    </h3>
                    <div className="skills-grid">
                        {getSkillsByCategory(frontendSkills).map((skill, id) => (
                            <div className="skill--box" key={id} style={skillBoxStyle}>
                                <img src={skillsImage(skill)} alt={skill} />
                                <h3 style={{color: theme.tertiary}}>
                                    {skill}
                                </h3>
                            </div>
                        ))}
                    </div>
                </div>
                
                {/* Backend Skills */}
                <div className="skillCategory">
                    <h3 style={categoryStyle}>
                        <span style={{color: 'white'}}>Back</span>
                        <span style={{color: theme.primary}}>end</span>
                    </h3>
                    <div className="skills-grid">
                        {getSkillsByCategory(backendSkills).map((skill, id) => (
                            <div className="skill--box" key={id} style={skillBoxStyle}>
                                <img src={skillsImage(skill)} alt={skill} />
                                <h3 style={{color: theme.tertiary}}>
                                    {skill}
                                </h3>
                            </div>
                        ))}
                    </div>
                </div>
                
                {/* Platform & Tools Skills */}
                <div className="skillCategory">
                    <h3 style={categoryStyle}>
                        <span style={{color: 'white'}}>Platforms</span>
                        <span style={{color: theme.primary}}> & Tools</span>
                    </h3>
                    <div className="skills-grid">
                        {getSkillsByCategory(platformSkills).map((skill, id) => (
                            <div className="skill--box" key={id} style={skillBoxStyle}>
                                <img src={skillsImage(skill)} alt={skill} />
                                <h3 style={{color: theme.tertiary}}>
                                    {skill}
                                </h3>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skills;